/**
 * DDay Templates Package Configuration
 *
 * Centralized config for @kiltechco/dday-templates package.
 * Import getPackageConfig() wherever you call setPackageConfig().
 */

import { getCdnUrl } from '@/utils/env'
import { warnIfMapsKeyMissing } from '@/src/lib/maps-config-guard'
import { getRuntimePublicConfigValue } from '@/src/lib/runtime-public-config'

type Environment = 'development' | 'staging' | 'production'

/**
 * Get the current environment
 */
function getEnvironment(): Environment {
  const env =
    getRuntimePublicConfigValue('NEXT_PUBLIC_ENV') ||
    process.env.NEXT_PUBLIC_ENV
  if (env === 'staging') return 'staging'
  if (env === 'production') return 'production'
  return 'development'
}

/**
 * Get package configuration object
 *
 * Usage:
 * ```ts
 * const pkg = await import('@kiltechco/dday-templates')
 * pkg.setPackageConfig(getPackageConfig())
 * ```
 */
export function getPackageConfig() {
  const googleMapsApiKey =
    getRuntimePublicConfigValue('NEXT_PUBLIC_GOOGLE_MAPS_API_KEY') ||
    process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY
  const googleMapsMapId =
    getRuntimePublicConfigValue('NEXT_PUBLIC_GOOGLE_MAPS_MAP_ID') ||
    process.env.NEXT_PUBLIC_GOOGLE_MAPS_MAP_ID
  // Stationery back-of-card Or visit {url}; set in Vercel per env (e.g. invite.dday.io, invite.stg.dday.io)
  const invitationBaseUrl =
    getRuntimePublicConfigValue('NEXT_PUBLIC_INVITE_BASE_URL') ||
    process.env.NEXT_PUBLIC_INVITE_BASE_URL

  warnIfMapsKeyMissing(googleMapsApiKey, 'ddayTemplates.getPackageConfig')

  return {
    environment: getEnvironment(),
    cdnBaseUrl: getCdnUrl(),
    googleMapsApiKey,
    googleMapsMapId,
    invitationBaseUrl,
  }
}
